module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.skins.images.length) ? _c('div', {
    staticClass: "ui six stackable cards",
    attrs: {
      "id": "skins-cards"
    }
  }, _vm._l((_vm.skins.visible_images), function(item) {
    return _c('div', {
      class: 'col-sm-6 col-md-4 card col-lg-' + _vm.bigScreenSkins,
      attrs: {
        "data-skin-id": item.id
      }
    }, [_c('img', {
      staticClass: "card-img-top",
      attrs: {
        "src": _vm.baseUrl2 + '/public/images/skins/' + item.skin_name + '.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-block"
    }, [_c('div', {
      staticClass: "card-text"
    }, [(_vm.role >= 33) ? _c('span', [_vm._v(_vm._s(item.ip))]) : _vm._e(), _vm._v(" "), (_vm.role >= 33) ? _c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(item.approved_by))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer"
    }, [_c('h4', {
      staticClass: "text-center card-title mt-3"
    }, [_vm._v(_vm._s(item.user_id))]), _vm._v(" "), _c('h4', {
      staticClass: "text-center card-title mt-3"
    }, [_vm._v(_vm._s(decodeURI(item.nickname)))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger float-right btn-sm",
      on: {
        "click": function($event) {
          _vm.removePrivateSkinDB(item.id, item.skin_name)
        }
      }
    }, [_vm._v("Delete")])])])
  })) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Private Skins\n      "), _c('small', [_vm._v("Private Skin list")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e8b2d3ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/skins/Private.vue
// module id = 323
// module chunks = 2